<template>
  <div class="bg-white">
    <div class="relative z-index1 h-full w-full">
      <div class="sm-joinus-svg">
        <CoverPage />
        <RosettaLife />
      </div>
    </div>
    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>

<script>
import CoverPage from "./components/CoverPage.vue";
import RosettaLife from "./components/Rosetta-Life.vue";
import Footer from "../../Footer.vue";
import DownloadApp from "@/views/home/components/DownloadApp.vue";
export default {
  components: { CoverPage, RosettaLife, Footer, DownloadApp },
};
</script>

<style></style>
